import { spawn } from 'redux-saga/effects';
import watchSubmitPrimaryAuth from './submitPrimaryAuth'

export default function* primaryAuthSaga() {
  yield spawn(watchSubmitPrimaryAuth)
}

